module.exports = __webpack_public_path__ + "assets/img/ic-warning-w.7e180036.svg";